<template>
	<div>
		<span class="large-button mini no-margin" @click="showEventsModal = true" v-html="fullAccess ? ( events.length > 0 ? 'View/edit events' : 'Add events' ) : 'View events'" />

		<div class="modal" v-if="showEventsModal">
			<div :class="{ 'modal-wrap': true }">
				<div class="modal-inner">
					<h2 class="modal-title">{{ title }}<span class="close" @click="close">X</span></h2>

					<Loading v-if="loading !== ''" position="inner" :text="loading" />

					<span class="large-button mini flip-colours add-event-btn" @click="showAddEvent = true" v-if="project.access === 'full-access'"
						>Add a new event</span
					>

					<div class="modal-inner-scroll">
						<div class="events-wrap">
							<p v-if="events.length === 0">There are no events to display at the moment.</p>
							<div class="event-item" v-for="(event, eventIndex) in events" :key="eventIndex">
								<br v-if="eventIndex > 0" />

								<span class="event-date" v-html="event.date" /><br />

								<span class="event-events" v-for="(event2, eventIndex2) in event.events" :key="'e' + eventIndex2">
									<span v-html="event2.events.join('<br>')" v-if="!hidden.includes(event2._id)" /> &nbsp;<span
										class="delete-event"
										@click="deleteEvent(event2._id)"
										v-if="event2.canDelete && !hidden.includes(event2._id) && fullAccess"
										>X</span
									>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" v-if="showAddEvent">
			<div :class="{ 'modal-wrap': true }">
				<div class="modal-inner">
					<h2 class="modal-title">Add a new event<span class="close" @click="closeAddEvent">X</span></h2>
					<Loading v-if="loading !== ''" position="inner" :text="loading" />
					<div class="modal-inner-scroll">
						<form>
							<div class="date-inputs">
								<div class="form-group">
									<label for="day">Day:</label>
									<v-select
										v-model="newEvent.day"
										:options="days"
										:searchable="false"
										:clearable="false"
										:append-to-body="true"
										:reduce="(option) => option._id"
									></v-select>
								</div>
								<div class="form-group">
									<label for="month">Month:</label>
									<v-select
										v-model="newEvent.month"
										:options="months"
										:searchable="false"
										:clearable="false"
										:append-to-body="true"
										:reduce="(option) => option._id"
									></v-select>
								</div>
								<div class="form-group">
									<label for="year">Year:</label>
									<v-select
										v-model="newEvent.year"
										:options="years"
										:searchable="false"
										:clearable="false"
										:append-to-body="true"
										:reduce="(option) => option._id"
									></v-select>
								</div>
							</div>
							<FormInput
								type="textarea"
								v-model="newEvent.content"
								name="content"
								label="Event description"
								placeholder="A short description of the event..."
								theRef="content"
								:autoResize="true"
								:autoResizeMaxHeight="160"
								:noMarginBottom="true"
							/>
							<span class="large-button" @click="addEvent">Add event</span>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ApiService from "./../services/api.service";
	import FormInput from "./Form/Input.vue";
	import Loading from "./Loading.vue";
	export default {
		name: "EventActions",
		components: {
			FormInput,
			Loading,
		},
		props: {
			events: {
				type: Array,
				default: () => {
					return [];
				},
			},
			project: {
				type: Object,
			},
			showEvents: {
				type: Boolean,
				default: false,
			},
		},
		watch: {
			showEvents(val) {
				if ( val ) this.showEventsModal = true;
			},
		},
		data() {
			const currentDate = new Date();
			return {
				showEventsModal: false,
				showAddEvent: false,
				loading: "",
				hidden: [],
				newEvent: {
					day: currentDate.getDate(),
					month: currentDate.getMonth() + 1, // getMonth() returns 0-11, so we add 1
					year: currentDate.getFullYear(),
					content: "",
				},
			};
		},
		computed: {
			fullAccess() {
				return !!this.project && this.project.access === "full-access";
			},
			title() {
				return "Events";
			},
			days() {
				const getOrdinalSuffix = (day) => {
					if (day > 3 && day < 21) return "th";
					switch (day % 10) {
						case 1:
							return "st";
						case 2:
							return "nd";
						case 3:
							return "rd";
						default:
							return "th";
					}
				};

				return Array.from({ length: 31 }, (_, i) => {
					const day = i + 1;
					return { label: `${day}${getOrdinalSuffix(day)}`, _id: day };
				});
			},
			months() {
				const monthNames = [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December",
				];
				return monthNames.map((name, index) => ({ label: name, _id: index + 1 }));
			},
			years() {
				const currentYear = new Date().getFullYear();
				return Array.from({ length: 12 }, (_, i) => ({ label: currentYear - 2 + i, _id: currentYear - 2 + i }));
			},
		},
		methods: {
			deleteEvent(eventId) {
				this.$dialog
					.confirm("Are you sure you want to delete this event?", { okText: "Yes", cancelText: "Cancel" })
					.then(
						function() {
							this.loading = "One moment...";
							this.hidden.push(eventId);

							ApiService.delete("projects/actions/" + this.project._id + "/" + eventId)
								.then(
									function(info) {
										this.loading = "";
										this.reloadChart();
									}.bind(this)
								)
								.catch(
									function(err) {
										this.loading = "";
										this.$snotify.error("Error adding event", "Add event");
									}.bind(this)
								);
						}.bind(this)
					)
					.catch(function() {});
			},

			addEvent() {
				if (!this.newEvent.content) {
					this.$snotify.error("Please enter an event description", "Add event");
					return;
				}

				this.loading = "One moment...";

				ApiService.post("projects/actions/" + this.project._id, this.newEvent)
					.then(
						function(info) {
							this.loading = "";
							this.reloadChart();
							this.newEvent = {
								day: new Date().getDate(),
								month: new Date().getMonth() + 1,
								year: new Date().getFullYear(),
								content: "",
							};
						}.bind(this)
					)
					.catch(
						function(err) {
							this.loading = "";
							this.$snotify.error("Error adding event", "Add event");
						}.bind(this)
					);

				this.$emit("add-event", this.newEvent);
				this.closeAddEvent();
			},

			close() {
				this.showEventsModal = false;
				this.$emit("close");
			},

			closeAddEvent() {
				this.showAddEvent = false;
				this.$emit("close-add-event");
			},
			reloadChart() {
				this.$emit("reload-chart");
			},
		},
		mounted() {},
	};
</script>
<style lang="less" scoped>
	@import "./../assets/css/less/_helper.less";
	@import "./../assets/css/less/_settings.less";

	.events-wrap {
		.event-item {
			.event-date {
				font-weight: bold;
			}
		}
	}

	.event-events {
		display: block;
	}

	.add-event-btn {
		position: absolute;
		top: -4px;
		right: 60px;
	}

	.form-group {
		margin-bottom: 15px;
	}

	label {
		display: block;
		margin-bottom: 5px;
	}

	.v-select {
		width: 100%;
	}

	.date-inputs {
		display: flex;
		gap: 10px;
	}

	.form-group {
		flex: 1;
		margin-bottom: 15px;
	}

	label {
		display: block;
		margin-bottom: 5px;
	}

	// You may need to adjust these styles to fit your design
	.v-select {
		width: 100%;
	}
	.delete-event {
		color: @red;
		font-size: 0.8em;
		cursor: pointer;
	}
</style>
